
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/standard-terms-and-conditions-for-services",
      function () {
        return require("private-next-pages/legal/standard-terms-and-conditions-for-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/standard-terms-and-conditions-for-services"])
      });
    }
  